import type { MapGroupBy } from '../model/types';

interface MapGroupByConfig {
  labelKey: string;
  /** Name of the grouping dimension, prefixed to the cluster name as legacy does. */
  dimensionKey?: string;
}

export const MAP_GROUP_BY_CONFIG: Record<MapGroupBy, MapGroupByConfig> = {
  location: { labelKey: 'welcome.map.groupby.loc.label' },
  country: { labelKey: 'welcome.map.groupby.country.label', dimensionKey: 'org.country.label' },
  region: { labelKey: 'welcome.map.groupby.region.label', dimensionKey: 'region.name.label' },
  subregion: { labelKey: 'welcome.map.groupby.subregion.label', dimensionKey: 'subregion.name.label' },
  locationGroup: { labelKey: 'welcome.map.groupby.locgroup.label', dimensionKey: 'location.parentSite.label' }
};
